import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import RestrictedView from '../Restricted';
import { USER_PERMISSIONS } from '../Restricted/PERMISSIONS';
import './index.scss';
import BannedIcon from '../BannedIcon';

const Contact = ({
    phone,
    email,
    account_id,
    contact_id,

    isPhoneSystemSupported,
    hasEmailIntegrations = true,

    onCallClick,
    onTextClick,
    onEmailClick,
    onNoteClick,

    ActivityPopup,
    TextIcon,
    callActivityProps,
    emailActivityProps,

    leftSideContent,
    isActionsVisible = true,
    isArchived,
    isFixedWidth = true,
    callSuspended
}) => {
    const [openActivityForm, setOpenActivityForm] = useState('');

    const notePermission = contact_id
        ? USER_PERMISSIONS.CONTACTS_ADD
        : isActionsVisible
            ? USER_PERMISSIONS.ACCOUNT_ADD
            : USER_PERMISSIONS.MASTER_ACCOUNT_ADD;

    const emailPermission = contact_id
        ? USER_PERMISSIONS.CONTACTS_ADD
        : USER_PERMISSIONS.ACCOUNT_ADD;

    const closeActivityForm = () => setOpenActivityForm('');

    const openActivity = (type) => () => {
        setOpenActivityForm(type);
    };

    const handleAction = (callback) => {
        if (!isPhoneSystemSupported) {
            closeActivityForm();
        }

        callback?.();
    };

    const renderPhoneAction = () => {
        if (isPhoneSystemSupported) {
            if (!callSuspended) {
                return (
                    <Icon
                        className="fas fa-phone"
                        link
                        disabled={!phone || isArchived || callSuspended}
                        onClick={onCallClick}
                    />
                );
            }
            return (
                <BannedIcon 
                    iconName={"fas fa-phone"}
                    primary
                    style={{ fontSize: "1.25em" }}
                    banIconSize='tiny'
                />
            )
        }

        return (
            <ActivityPopup
                trigger={<Icon className="fas fa-phone" link />}
                activityProps={callActivityProps}
                open={openActivityForm === 'call'}
                onOpen={openActivity('call')}
                onClose={closeActivityForm}
                position="bottom right"
                disabled={isArchived}
            />
        );
    };

    const renderEmailAction = () => {
        if (!email || isArchived) {
            return (
                <Icon
                    className="fas fa-envelope"
                    link
                    disabled
                />
            );
        }

        if (hasEmailIntegrations) {
            return (
                <RestrictedView
                    type="disabled"
                    userPermission={emailPermission}
                >
                    <Icon
                        className="fas fa-envelope"
                        link
                        onClick={() => handleAction(onEmailClick)}
                        disabled={isArchived}
                    />
                </RestrictedView>
            );
        }

        return (
            <ActivityPopup
                trigger={<Icon className="fas fa-envelope" link disabled={isArchived} />}
                activityProps={emailActivityProps}
                open={openActivityForm === 'email'}
                onOpen={openActivity('email')}
                onClose={closeActivityForm}
                position="bottom right"
            />
        );
    };

    return (
        <div className="Contact">
            {leftSideContent && (
                <div className={`Contact__left-side ${isFixedWidth ? 'Contact__left-side--fixed-width' : ''} `}>
                    {leftSideContent}
                </div>
            )}

            <div className="Contact__actions">
                {isActionsVisible && (
                    <>
                        {renderPhoneAction()}

                        <TextIcon
                            account_id={account_id}
                            contact_id={contact_id}
                            phone={phone}
                            isActivityFormOpen={openActivityForm === 'text'}
                            onOpenActivityForm={openActivity('text')}
                            onCloseActivityForm={closeActivityForm}
                            onOpenTextModal={onTextClick}
                            disabled={isArchived}
                        />

                        {renderEmailAction()}
                    </>
                )}

                <RestrictedView
                    type="disabled"
                    userPermission={notePermission}
                >
                    <Icon
                        className="fa-sharp fa-solid fa-pen-clip"
                        link
                        onClick={() => handleAction(onNoteClick)}
                        disabled={isArchived}
                    />
                </RestrictedView>
            </div>
        </div>
    );
};

export default Contact;
